import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface AssetEventGeneralCount extends AttributesMixin<typeof AssetEventGeneralCount> { }
@define
export class AssetEventGeneralCount extends Model {
    static endpoint = restfulIO('/api/v1/assetmaster/assetsEvents/general-count');

    static attributes = {
        importJobId: Number,
        uid: String,
        eventTypeId: Number,
        success: Boolean,
        count: Number
    };
}
